unit View.Segmento.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewSegmentoEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbId: TLabel;
    edId: TDBEdit;
    lbNome: TLabel;
    edNome: TDBEdit;
    lbExcluido: TLabel;
    edExcluido: TDBEdit;
    lbInclusao: TLabel;
    edInclusao: TDBEdit;
    lbAlteracao: TLabel;
    edAlteracao: TDBEdit;
    lbExclusao: TLabel;
    edExclusao: TDBEdit;
    XDataClientSegmentoGet: TXDataWebClient;
    XDataClientSegmentoDelete: TXDataWebClient;
    SegmentoDataset: TXDataWebDataSet;
    SegmentoDatasetId: TIntegerField;
    SegmentoDatasetNome: TStringField;
    SegmentoDatasetExcluido: TBooleanField;
    SegmentoDatasetInclusao: TDateTimeField;
    SegmentoDatasetAlteracao: TDateTimeField;
    SegmentoDatasetExclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientSegmentoGetLoad(Response: TXDataClientResponse);
    procedure XDataClientSegmentoDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientSegmentoDeleteError(Error: TXDataClientError);
    procedure SegmentoDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewSegmentoEdit: TFViewSegmentoEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSegmentoEdit }

procedure TFViewSegmentoEdit.btSaveClick(Sender: TObject);
begin
  if SegmentoDataset.State in dsEditModes then
  begin
        SegmentoDataset.Post;
    SegmentoDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewSegmentoEdit.btDeleteClick(Sender: TObject);
begin
  if SegmentoDataset.State in dsEditModes then
    SegmentoDataset.Post;
  XDataClientSegmentoDelete.Delete(SegmentoDataset.EntitySetName,
    TJSObject(SegmentoDataset.CurrentData));
end;


class function TFViewSegmentoEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewSegmentoEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewSegmentoEdit.InsertEntity;
begin
  SegmentoDataset.Close;
  SegmentoDataset.SetJsonData('{}');
  SegmentoDataset.Open;
  SegmentoDataset.Insert;
end;

class function TFViewSegmentoEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSegmentoEdit(AForm).FInserting := AInserting;
    TFViewSegmentoEdit(AForm).FId := AId;
    TFViewSegmentoEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewSegmentoEdit(AForm).InsertEntity
    else
      TFViewSegmentoEdit(AForm).LoadEntity;
    TFViewSegmentoEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewSegmentoEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewSegmentoEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    SegmentoDataset.Connection.Model.DefaultSchema.FindEntityType(
      SegmentoDataset.EntitySetName
    )
  );
  XDataClientSegmentoGet.Get(SegmentoDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewSegmentoEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewSegmentoEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSegmentoEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewSegmentoEdit.XDataClientSegmentoGetLoad(Response: TXDataClientResponse);
begin
  SegmentoDataset.Close;
  SegmentoDataset.SetJsonData(Response.Result);
  SegmentoDataset.Open;
  
  SegmentoDataset.Edit;  
end;

procedure TFViewSegmentoEdit.XDataClientSegmentoDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewSegmentoEdit.XDataClientSegmentoDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewSegmentoEdit.SegmentoDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewSegmentoEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewSegmentoEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbId := TLabel.Create('view.segmento.form.lbId');
  lbNome := TLabel.Create('view.segmento.form.lbNome');
  lbExcluido := TLabel.Create('view.segmento.form.lbExcluido');
  lbInclusao := TLabel.Create('view.segmento.form.lbInclusao');
  lbAlteracao := TLabel.Create('view.segmento.form.lbAlteracao');
  lbExclusao := TLabel.Create('view.segmento.form.lbExclusao');
  pnlMessage := TPanel.Create('view.segmento.form.message');
  lbMessage := TLabel.Create('view.segmento.form.message.label');
  btCloseMessage := TButton.Create('view.segmento.form.message.button');
  btCancel := TButton.Create('view.segmento.form.btBack');
  btSave := TButton.Create('view.segmento.form.btSave');
  btDelete := TButton.Create('view.segmento.form.btDelete');
  edId := TDBEdit.Create('view.segmento.form.edId');
  edNome := TDBEdit.Create('view.segmento.form.edNome');
  edExcluido := TDBEdit.Create('view.segmento.form.edExcluido');
  edInclusao := TDBEdit.Create('view.segmento.form.edInclusao');
  edAlteracao := TDBEdit.Create('view.segmento.form.edAlteracao');
  edExclusao := TDBEdit.Create('view.segmento.form.edExclusao');
  DataSource := TDataSource.Create(Self);
  SegmentoDataset := TXDataWebDataSet.Create(Self);
  SegmentoDatasetId := TIntegerField.Create(Self);
  SegmentoDatasetNome := TStringField.Create(Self);
  SegmentoDatasetExcluido := TBooleanField.Create(Self);
  SegmentoDatasetInclusao := TDateTimeField.Create(Self);
  SegmentoDatasetAlteracao := TDateTimeField.Create(Self);
  SegmentoDatasetExclusao := TDateTimeField.Create(Self);
  XDataClientSegmentoGet := TXDataWebClient.Create(Self);
  XDataClientSegmentoDelete := TXDataWebClient.Create(Self);

  lbId.BeforeLoadDFMValues;
  lbNome.BeforeLoadDFMValues;
  lbExcluido.BeforeLoadDFMValues;
  lbInclusao.BeforeLoadDFMValues;
  lbAlteracao.BeforeLoadDFMValues;
  lbExclusao.BeforeLoadDFMValues;
  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  edId.BeforeLoadDFMValues;
  edNome.BeforeLoadDFMValues;
  edExcluido.BeforeLoadDFMValues;
  edInclusao.BeforeLoadDFMValues;
  edAlteracao.BeforeLoadDFMValues;
  edExclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  SegmentoDataset.BeforeLoadDFMValues;
  SegmentoDatasetId.BeforeLoadDFMValues;
  SegmentoDatasetNome.BeforeLoadDFMValues;
  SegmentoDatasetExcluido.BeforeLoadDFMValues;
  SegmentoDatasetInclusao.BeforeLoadDFMValues;
  SegmentoDatasetAlteracao.BeforeLoadDFMValues;
  SegmentoDatasetExclusao.BeforeLoadDFMValues;
  XDataClientSegmentoGet.BeforeLoadDFMValues;
  XDataClientSegmentoDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewSegmentoEdit';
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbId.SetParentComponent(Self);
    lbId.Name := 'lbId';
    lbId.Left := 24;
    lbId.Top := 192;
    lbId.Width := 14;
    lbId.Height := 13;
    lbId.Caption := 'Id:';
    lbId.HeightPercent := 100.000000000000000000;
    lbId.WidthPercent := 100.000000000000000000;
    lbNome.SetParentComponent(Self);
    lbNome.Name := 'lbNome';
    lbNome.Left := 24;
    lbNome.Top := 219;
    lbNome.Width := 31;
    lbNome.Height := 13;
    lbNome.Caption := 'Nome:';
    lbNome.HeightPercent := 100.000000000000000000;
    lbNome.WidthPercent := 100.000000000000000000;
    lbExcluido.SetParentComponent(Self);
    lbExcluido.Name := 'lbExcluido';
    lbExcluido.Left := 24;
    lbExcluido.Top := 246;
    lbExcluido.Width := 43;
    lbExcluido.Height := 13;
    lbExcluido.Caption := 'Excluido:';
    lbExcluido.HeightPercent := 100.000000000000000000;
    lbExcluido.WidthPercent := 100.000000000000000000;
    lbInclusao.SetParentComponent(Self);
    lbInclusao.Name := 'lbInclusao';
    lbInclusao.Left := 24;
    lbInclusao.Top := 273;
    lbInclusao.Width := 44;
    lbInclusao.Height := 13;
    lbInclusao.Caption := 'Inclusao:';
    lbInclusao.HeightPercent := 100.000000000000000000;
    lbInclusao.WidthPercent := 100.000000000000000000;
    lbAlteracao.SetParentComponent(Self);
    lbAlteracao.Name := 'lbAlteracao';
    lbAlteracao.Left := 24;
    lbAlteracao.Top := 300;
    lbAlteracao.Width := 50;
    lbAlteracao.Height := 13;
    lbAlteracao.Caption := 'Alteracao:';
    lbAlteracao.HeightPercent := 100.000000000000000000;
    lbAlteracao.WidthPercent := 100.000000000000000000;
    lbExclusao.SetParentComponent(Self);
    lbExclusao.Name := 'lbExclusao';
    lbExclusao.Left := 24;
    lbExclusao.Top := 327;
    lbExclusao.Width := 46;
    lbExclusao.Height := 13;
    lbExclusao.Caption := 'Exclusao:';
    lbExclusao.HeightPercent := 100.000000000000000000;
    lbExclusao.WidthPercent := 100.000000000000000000;
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.TabOrder := 0;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.HeightPercent := 100.000000000000000000;
    lbMessage.WidthPercent := 100.000000000000000000;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.HeightPercent := 100.000000000000000000;
    btCloseMessage.WidthPercent := 100.000000000000000000;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.HeightPercent := 100.000000000000000000;
    btDelete.TabOrder := 5;
    btDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    edId.SetParentComponent(Self);
    edId.Name := 'edId';
    edId.Left := 221;
    edId.Top := 189;
    edId.Width := 200;
    edId.Height := 21;
    edId.HeightPercent := 100.000000000000000000;
    edId.TabOrder := 6;
    edId.Text := 'edId';
    edId.WidthPercent := 100.000000000000000000;
    edId.DataField := 'Id';
    edId.DataSource := DataSource;
    edNome.SetParentComponent(Self);
    edNome.Name := 'edNome';
    edNome.Left := 221;
    edNome.Top := 216;
    edNome.Width := 200;
    edNome.Height := 21;
    edNome.HeightPercent := 100.000000000000000000;
    edNome.TabOrder := 7;
    edNome.Text := 'edNome';
    edNome.WidthPercent := 100.000000000000000000;
    edNome.DataField := 'Nome';
    edNome.DataSource := DataSource;
    edExcluido.SetParentComponent(Self);
    edExcluido.Name := 'edExcluido';
    edExcluido.Left := 221;
    edExcluido.Top := 243;
    edExcluido.Width := 200;
    edExcluido.Height := 21;
    edExcluido.HeightPercent := 100.000000000000000000;
    edExcluido.TabOrder := 8;
    edExcluido.Text := 'edExcluido';
    edExcluido.WidthPercent := 100.000000000000000000;
    edExcluido.DataField := 'Excluido';
    edExcluido.DataSource := DataSource;
    edInclusao.SetParentComponent(Self);
    edInclusao.Name := 'edInclusao';
    edInclusao.Left := 221;
    edInclusao.Top := 270;
    edInclusao.Width := 200;
    edInclusao.Height := 21;
    edInclusao.HeightPercent := 100.000000000000000000;
    edInclusao.TabOrder := 9;
    edInclusao.Text := 'edInclusao';
    edInclusao.WidthPercent := 100.000000000000000000;
    edInclusao.DataField := 'Inclusao';
    edInclusao.DataSource := DataSource;
    edAlteracao.SetParentComponent(Self);
    edAlteracao.Name := 'edAlteracao';
    edAlteracao.Left := 221;
    edAlteracao.Top := 297;
    edAlteracao.Width := 200;
    edAlteracao.Height := 21;
    edAlteracao.HeightPercent := 100.000000000000000000;
    edAlteracao.TabOrder := 10;
    edAlteracao.Text := 'edAlteracao';
    edAlteracao.WidthPercent := 100.000000000000000000;
    edAlteracao.DataField := 'Alteracao';
    edAlteracao.DataSource := DataSource;
    edExclusao.SetParentComponent(Self);
    edExclusao.Name := 'edExclusao';
    edExclusao.Left := 221;
    edExclusao.Top := 324;
    edExclusao.Width := 200;
    edExclusao.Height := 21;
    edExclusao.HeightPercent := 100.000000000000000000;
    edExclusao.TabOrder := 11;
    edExclusao.Text := 'edExclusao';
    edExclusao.WidthPercent := 100.000000000000000000;
    edExclusao.DataField := 'Exclusao';
    edExclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := SegmentoDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    SegmentoDataset.SetParentComponent(Self);
    SegmentoDataset.Name := 'SegmentoDataset';
    SegmentoDataset.AfterApplyUpdates := SegmentoDatasetAfterApplyUpdates;
    SegmentoDataset.EntitySetName := 'Segmentos';
    SegmentoDataset.Connection := DMConnection.ApiConnection;
    SegmentoDataset.Left := 176;
    SegmentoDataset.Top := 8;
    SegmentoDatasetId.SetParentComponent(SegmentoDataset);
    SegmentoDatasetId.Name := 'SegmentoDatasetId';
    SegmentoDatasetId.FieldName := 'Id';
    SegmentoDatasetId.Required := True;
    SegmentoDatasetNome.SetParentComponent(SegmentoDataset);
    SegmentoDatasetNome.Name := 'SegmentoDatasetNome';
    SegmentoDatasetNome.FieldName := 'Nome';
    SegmentoDatasetNome.Required := True;
    SegmentoDatasetNome.Size := 255;
    SegmentoDatasetExcluido.SetParentComponent(SegmentoDataset);
    SegmentoDatasetExcluido.Name := 'SegmentoDatasetExcluido';
    SegmentoDatasetExcluido.FieldName := 'Excluido';
    SegmentoDatasetExcluido.Required := True;
    SegmentoDatasetInclusao.SetParentComponent(SegmentoDataset);
    SegmentoDatasetInclusao.Name := 'SegmentoDatasetInclusao';
    SegmentoDatasetInclusao.FieldName := 'Inclusao';
    SegmentoDatasetAlteracao.SetParentComponent(SegmentoDataset);
    SegmentoDatasetAlteracao.Name := 'SegmentoDatasetAlteracao';
    SegmentoDatasetAlteracao.FieldName := 'Alteracao';
    SegmentoDatasetExclusao.SetParentComponent(SegmentoDataset);
    SegmentoDatasetExclusao.Name := 'SegmentoDatasetExclusao';
    SegmentoDatasetExclusao.FieldName := 'Exclusao';
    XDataClientSegmentoGet.SetParentComponent(Self);
    XDataClientSegmentoGet.Name := 'XDataClientSegmentoGet';
    XDataClientSegmentoGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSegmentoGet, Self, 'OnLoad', 'XDataClientSegmentoGetLoad');
    XDataClientSegmentoGet.Left := 64;
    XDataClientSegmentoGet.Top := 8;
    XDataClientSegmentoDelete.SetParentComponent(Self);
    XDataClientSegmentoDelete.Name := 'XDataClientSegmentoDelete';
    XDataClientSegmentoDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientSegmentoDelete, Self, 'OnLoad', 'XDataClientSegmentoDeleteLoad');
    SetEvent(XDataClientSegmentoDelete, Self, 'OnError', 'XDataClientSegmentoDeleteError');
    XDataClientSegmentoDelete.Left := 64;
    XDataClientSegmentoDelete.Top := 56;
  finally
    lbId.AfterLoadDFMValues;
    lbNome.AfterLoadDFMValues;
    lbExcluido.AfterLoadDFMValues;
    lbInclusao.AfterLoadDFMValues;
    lbAlteracao.AfterLoadDFMValues;
    lbExclusao.AfterLoadDFMValues;
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    edId.AfterLoadDFMValues;
    edNome.AfterLoadDFMValues;
    edExcluido.AfterLoadDFMValues;
    edInclusao.AfterLoadDFMValues;
    edAlteracao.AfterLoadDFMValues;
    edExclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    SegmentoDataset.AfterLoadDFMValues;
    SegmentoDatasetId.AfterLoadDFMValues;
    SegmentoDatasetNome.AfterLoadDFMValues;
    SegmentoDatasetExcluido.AfterLoadDFMValues;
    SegmentoDatasetInclusao.AfterLoadDFMValues;
    SegmentoDatasetAlteracao.AfterLoadDFMValues;
    SegmentoDatasetExclusao.AfterLoadDFMValues;
    XDataClientSegmentoGet.AfterLoadDFMValues;
    XDataClientSegmentoDelete.AfterLoadDFMValues;
  end;
end;

end.
